// extracted by mini-css-extract-plugin
export default {"left_box":"index_left_box_Awki-","dbox":"index_dbox_x3Ts-"};